import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-token',
  templateUrl: './access-token.component.html',
  styleUrls: ['./access-token.component.scss'],
})
export class AccessTokenComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
